import { render } from "./Lesson.vue?vue&type=template&id=bc5af3aa"
import script from "./Lesson.vue?vue&type=script&lang=js"
export * from "./Lesson.vue?vue&type=script&lang=js"
script.render = render

export default script